import React from "react";
import { MEASUREMENTS_META } from "./graph_settings";
import moment from "moment";
import cropr from "../shared/utils/cropr";
import { _ } from "../shared/utils/legacy";

class TimelineHelper extends React.Component {
  static getFirstDaysOfMonths(start, end) {
    const result = [];
    let date = start.startOf("month");
    result.push(date.unix());
    while (date.isBefore(end)) {
      date = date.add(2, "M");
      result.push(date.unix());
    }
    return result;
  }

  static getRecordDateByTheme(records, themeId) {
    const matches = _.sortBy(
      _.filter(records, (r) => _.filter(r.get("activities"), (a) => a.theme === themeId).length),
      (r) => r.get("date")
    );
    return matches.length ? matches[0].getDate() : null;
  }
  static getRecords(cropfield) {
    return cropr.records.filter((record) => record.get("cropfield") === cropfield.id);
  }

  static loadRecordData(records) {
    return records.map((r) => {
      return { date: r.getDate().unix(), records: 0, id: r.id };
    });
  }

  static getPlantDate(records) {
    return this.getRecordDateByTheme(records, 6);
  }

  static getHarvestDate(records) {
    return this.getRecordDateByTheme(records, 10);
  }

  static renderTooltip = (records, graphData, graphKey) => (props) => {
    return (
      <TimelineTooltip {...props} records={records} graphData={graphData} graphKey={graphKey} />
    );
  };
}

const TimelineTooltip = ({ graphKey, graphData, active, payload, label }) => {
  if (active && payload) {
    const content = [];
    let graphPayload = _.filter(graphData, (d) => {
      return d.date === label;
    });
    graphPayload.forEach((gpl) => {
      var keys = _.keys(gpl);
      if (_.contains(keys, "ndvi_avg") && (!graphKey || graphKey === "ndvi_avg")) {
        content.push({ label: "NDVI", value: cropr.toLocaleFixed(gpl.ndvi_avg, 2) });
      }
      if (_.contains(keys, "bm_std_min") && (!graphKey || graphKey === "ndvi_avg")) {
        content.push({
          label: gpl.name,
          value: `${cropr.toLocaleFixed(gpl.benchmark_ndvi, 2)} &plusmn;${cropr.toLocaleFixed(
            gpl.benchmark_std,
            2
          )}`,
        });
      }
      if (
        _.contains(keys, "air_temperature_mean") &&
        (!graphKey || graphKey === "air_temperature_mean")
      ) {
        content.push({
          label: MEASUREMENTS_META.air_temperature.unit,
          value: cropr.toLocaleFixed(gpl.air_temperature_mean, 2),
          // value: cropr.toLocaleFixed(pl.value, 2)
        });
      } else if (_.contains(keys, "soil_temp") && (!graphKey || graphKey === "soil_temp")) {
        content.push({
          label: MEASUREMENTS_META.soil_temperature.unit,
          value: cropr.toLocaleFixed(gpl.soil_temp, 2),
        });
      }
      if (
        _.contains(keys, "precipitation_sum") &&
        (!graphKey || graphKey === "precipitation_sum")
      ) {
        content.push({
          label: MEASUREMENTS_META.precipitation.unit,
          value: cropr.toLocaleFixed(gpl.precipitation_sum, 2),
        });
      }
      if (
        _.contains(keys, "precipitation_deficit_accum") &&
        (!graphKey || graphKey === "precipitation_deficit_accum") &&
        gpl.precipitation_deficit_accum
      ) {
        content.push({
          label: MEASUREMENTS_META.precipitation_deficit.unit,
          value: cropr.toLocaleFixed(gpl.precipitation_deficit_accum, 2),
        });
      }
      if (_.contains(keys, "records") && (!graphKey || graphKey === "records")) {
        cropr.records
          .get(gpl.id)
          .get("activities")
          .forEach((a) => {
            content.push({ label: cropr.theme[a.theme].name, value: cropr.detailString(a) });
          });
      }
    });
    return (
      <div className="timeline-tooltip">
        <div className="text-muted">{moment.unix(label).format("LL")}</div>
        {content.map((c, i) => (
          <div className="fieldset" key={i}>
            <label className="text-header font-weight-bold mb-0">{c.label}</label>
            <div className={"text"} dangerouslySetInnerHTML={{ __html: c.value }}></div>
          </div>
        ))}
      </div>
    );
  }

  return null;
};

export default TimelineHelper;
